import { Container } from './styles'
import reactIcon from '../../assets/react-icon.svg'
import linkedin from '../../assets/linkedin.svg'
import githubIcon from '../../assets/github.svg'
import whatsapp from '../../assets/whatsapp.svg'
import telegram from '../../assets/telegram.svg'
import instagramIcon from '../../assets/instagram.svg'
// import discordIcon from '../../assets/discord.png'
import Li from '../../assets/linkedin.svg'

export function Footer() {
  return (
    <Container className="footer">
      <a href="https://funkeycreators.com" className="logo">
        <span>funkeycreators</span>
        <span>.com</span>
      </a>
      <div>
        <p>
          funkeycreators © All CopyRights Reserved 2024-2026
          {/* <span>❤️</span> */}
        </p>
      </div>
      <div className="social-media">
    
         <a
          href="https://www.linkedin.com/in/funky-creators-358608238/"
          target="_blank"
          rel="noreferrer"
        >
          <img src={Li} alt="telegram" />
        </a>
        
      </div>
    </Container>
  )
}
